import EnhanceIcon from "assets/icons/enhance.svg?react";
import CustomFitIcon from "assets/icons/custom-Fit.svg?react";
import CuttingEdgeIcon from "assets/icons/cutting-Edge.svg?react";
import UnlockIndustryIcon from "assets/icons/unlock-Industry.svg?react";
import SaddleMeasurementIcon from "assets/icons/saddle-Measurement.svg?react";

export const partnerCardData = [
    {
      icon: <EnhanceIcon />,
      title: "Enhance Your Product",
      des: "Build better saddles while increasing market share.​",
    },
    {
      icon: <CuttingEdgeIcon />,
      title: "Cutting-Edge Technology",
      des: "Technology based on horse anatomy, leading saddle fitting experts and proven methodology.",
    },
    {
      icon: <SaddleMeasurementIcon />,
      title: "Revolutionizing Saddle Measurement",
      des: "SaddleFit technology will be the only way to measure a horse for a saddle.",
    },
    {
      icon: <UnlockIndustryIcon />,
      title: "Unlock Industry Challenges",
      des: "Combining your manufacturing capabilities with SaddleFit’s design/engineering capabilities can solve the challenges of the industry.",
    },
    {
      icon: <CustomFitIcon />,
      title: "Create Custom-Fit Saddles",
      des: "Provide leading saddle manufacturers the tools to build saddles that are custom-fit to each horse's unique size and shape.",
    },
  ];